/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ApiResponse | undefined,
  (_params: vp.ELinxSetAccountRequest) => void,
  () => void,
  (params: vp.ELinxSetAccountRequest) => Promise<vp.ApiResponse>,
];

function usePostPaylinkSetAccount({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [params, setParams] = useState<vp.ELinxSetAccountRequest>();
  const [response, setResponse] = useState<vp.ApiResponse>();
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const { t } = useTranslation('translations', { keyPrefix: 'Common' });
  useEffect(() => {
    const sendRequest = async (requestParams: vp.ELinxSetAccountRequest) => {
      setDataFetchingInfo(true, `${t('defaultLoading')}`, 'fullScreen');

      const res = await api.postPaylinkSetAccount(requestParams, source);

      setResponse(res);
      if (res.Success) {
        sendJavaScriptMessage(requestParams);
      }
      setDataFetchingInfo(false);
      setSendRequest(false);
      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setSendRequest(false);
    },
    async (_params) => {
      const res = await api.postPaylinkSetAccount(_params, source);
      if (res.Success) {
        sendJavaScriptMessage(_params);
      }
      return res;
    },
  ];
}

function sendJavaScriptMessage(requestParams: vp.ELinxSetAccountRequest) {
  const Response = {
    ...requestParams,
    Step: 'ELINX_COMPLETE',
  };
  window.top?.postMessage(Response, '*');
  if (window.parent && window.parent !== window.top) {
    window.parent.postMessage(Response, '*');
  }
}
export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostPaylinkSetAccount);
